module.exports = __webpack_public_path__ + "static/img/seven_img05.6a4329f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/partner/seven_img05.png
// module id = mzsS
// module chunks = 6